module.exports = __webpack_public_path__ + "img/ad.a72b66f1.png";